module.exports = __webpack_public_path__ + "static/media/chatting.e158c5c8.png";